import { render, staticRenderFns } from "./LabelHeadersListPage.vue?vue&type=template&id=281be5e1&scoped=true&"
import script from "./LabelHeadersListPage.vue?vue&type=script&lang=ts&"
export * from "./LabelHeadersListPage.vue?vue&type=script&lang=ts&"
import style0 from "./LabelHeadersListPage.vue?vue&type=style&index=0&id=281be5e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281be5e1",
  null
  
)

export default component.exports